import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7xavy8id: FaireBrandEntity = {
  token: "b_7xavy8id",
  type: "brand",
  name: "Fontana Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f167e4910aafb82534eaee5e8aff6e2ff75478b510677809d5311038813e2707.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/714de119ca8113e95549802f40ea4b99a9c261716cfc63676f2ddeb2d06b412c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f167e4910aafb82534eaee5e8aff6e2ff75478b510677809d5311038813e2707.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/714de119ca8113e95549802f40ea4b99a9c261716cfc63676f2ddeb2d06b412c.png",
  location: "Lancaster, PA, USA",
  minimumOrderDollars: 160,
  rating: 4.9,
  reviewCount: 68,
  isTopShop: true,
  isInsider: true,
  description:
    "Fontana Candle Co. is setting the standard for non-toxic candles and clean home scenting. We believe what you breathe is just as important as what you eat, which is why we craft natural candles using only simple, safe ingredients. Our wax blend combines beeswax and coconut oil—free from petroleum byproducts, stabilizers, and synthetic dyes—and we scent exclusively with 100% pure essential oils and plant extracts. No hidden chemicals, just truly clean-burning candles you can trust.\n\nOur woodwick candles are hand poured in Lancaster County, Pennsylvania and were the first ever to be certified MADE SAFE®. Named Best New Natural Living Product of 2020, Fontana candles are a leading choice for anyone seeking essential oil candles that support wellness. \n\nWe’re expanding our line of natural candles and home scenting to ensure every room in your house is toxin-free, healthy, and filled with scents you love.\n\nThird party sales of our products on Amazon & Tiktok Shop are not permitted.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:07.995Z",
    importedBy: "entity-db-cli",
  },
};
